import { GetExternosDetalle } from "../../reducers/externoDetalle";

export interface ExternosListStore extends GetExternosDetalle {}

export const externosListStore: (state) => ExternosListStore = state => {
  const { externoDetalle } = state;
  return {
    externosDetalle: externoDetalle.externosDetalle,
    gettingExternosDetalle: externoDetalle.gettingExternosDetalle,
    gettingExternosDetalleError: externoDetalle.gettingExternosDetalleError
  };
};
